const initHomepageAnimations = () => {
  const main = document.querySelector("main[data-template='index']");
  if (!main) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = [];
  const addTargets = (selector, variant, stagger) => {
    const elements = Array.from(main.querySelectorAll(selector));
    if (!elements.length) return;

    elements.forEach((element, index) => {
      if (!element || element.classList.contains('home-reveal')) return;

      element.classList.add('home-reveal');
      if (variant && variant !== 'rise') {
        element.classList.add(`home-reveal--${variant}`);
      }

      if (stagger) {
        const cycle = Number.isFinite(stagger.cycle) ? Math.max(stagger.cycle, 1) : null;
        const staggerIndex = cycle ? index % cycle : Math.min(index, stagger.max);
        const delay = staggerIndex * stagger.step;
        element.style.setProperty('--home-animate-delay', `${delay}ms`);
      }

      targets.push(element);
    });
  };

  addTargets('.section-content-wrapper', 'rise');
  addTargets('.section-resource-list__header', 'left');
  addTargets('.resource-list__item', 'rise', { step: 80, max: 6 });
  addTargets('.section-resource-list__content', 'rise');
  addTargets('.instagram-vip__header', 'left');
  addTargets('.instagram-vip__card', 'zoom', { step: 90, max: 6, cycle: 3 });
  addTargets('[class^="ai-collections-showcase__item-"]', 'zoom', { step: 80, max: 6 });

  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries, observerInstance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in-view');
        observerInstance.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.15,
    }
  );

  targets.forEach((target) => observer.observe(target));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHomepageAnimations, { once: true });
} else {
  initHomepageAnimations();
}
